import { EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner,  EuiSpacer, EuiText, EuiTextColor } from '@elastic/eui';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { ItemInfoCPUser } from './item';
import { ModalConfiguracionRepartos } from './ModalConfiguracion';

export const InfoCPUserScreen = (props) =>{

    const {data, handleUpdate, refresh, user} = props;
    const refScreen = useRef();
    const [dataSave, setDataSave] = useState([])

    useEffect(()=>{data && setDataSave([...data])},[data])

    const total = useMemo(()=>{ 
        return dataSave.length>0 ? dataSave.map((item, i) => (item.porcentaje)).reduce((total, porcentaje) =>{return total + porcentaje;}) : 0
    },[dataSave])

    const isInvalidPorcentaje = useMemo(()=> total>100,[total])

    const totalMsg = useMemo(()=> {
        const color = total>100 ? "#BD271E" : "#008b8b";
        return <EuiFlexItem grow={false}><EuiText><strong><EuiTextColor style={{color:`${color}`}}>{`Total Porcentaje: ${total}%`}</EuiTextColor></strong></EuiText></EuiFlexItem> 
    },[total])

    const btnCongiguration = useMemo(()=> {
        if(dataSave.length>1){
            return(<EuiFlexItem>
                <ModalConfiguracionRepartos ref={refScreen} data={dataSave} user={user} handleUpdate={handleUpdate} refresh={refresh}/>
            </EuiFlexItem>)
        }else{return null}
    },[refScreen,dataSave,total])

    const generateStruct = useMemo(()=>{
        return dataSave && dataSave.map((d, i)=> {
            return(<>
                <EuiFlexItem>
                    <EuiFlexGroup className='item-list-cpUser'>
                        <ItemInfoCPUser data={d} readOnly error={isInvalidPorcentaje}/>
                    </EuiFlexGroup>
                </EuiFlexItem>
            </>)
        })
    },[dataSave,isInvalidPorcentaje])

    const titleUser = useMemo(()=> <EuiFlexItem style={{alignItems:'center'}}><EuiText><h4>{user!==undefined?`Repartos CPs de ${user}`:'Repartos CPs'}</h4></EuiText></EuiFlexItem>,[user])

    return(
        <div id='popover-cpUser'>
            <EuiFlexGroup className='title-cpUser-popover'>
                {titleUser}
            </EuiFlexGroup>
            <EuiSpacer size='l'/>
            <EuiFlexGroup direction='column' className='content-cpUser-popover'>
                {data!==undefined ? generateStruct : <EuiLoadingSpinner size='l'/>}
            </EuiFlexGroup>
            <EuiSpacer size='l'/>
            <EuiFlexGroup className={`bottom-panel-cpUser-popover${isInvalidPorcentaje?'-error':''}`} alignItems='center' justifyContent='flexEnd'>
                {btnCongiguration}
                {totalMsg}
            </EuiFlexGroup>
        </div>
    )
}